import styled from 'styled-components';
import { theme, tokens } from '@mindtickle/styles';

import Dropdown from '@mindtickle/dropdown';

export const PROFILE_THUMBNAIL_SIZE = 24;

export const StyledProfileDropdown = styled(Dropdown)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .mtdls-dropdown {
    border: 1px solid ${tokens.borderTokens.COLOR_BORDER_SECONDARY};
    border-radius: 0 0 4px 4px;
  }
  .mtdls-menu {
    box-shadow: ${theme.boxShadow.LEVEL2};
    border: 1px solid ${tokens.borderTokens.COLOR_BORDER_SECONDARY};

    &.mtdls-menu-vertical {
      border-radius: 0 0 4px 4px;
    }
  }
`;

export const StyledDropdownTriggerWrapper = styled.div<{ $isActive: boolean }>`
  padding: 4px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $isActive }) =>
    !$isActive ? tokens.bgTokens.COLOR_BG_DEFAULT : tokens.bgTokens.COLOR_BG_BRAND};

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? tokens.bgTokens.COLOR_BG_BRAND : tokens.bgTokens.COLOR_BG_TERTIARY};
  }
`;
